import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import * as UserActions from './../actions/user_actions';
import { bindActionCreators } from 'redux';
import { ModalDialogCommon } from './modal_dialog_common';
import { validate } from '../validations';

let ForgotUname = React.createClass({
    getInitialState() {
        return {
            someState: '',
            modal: false,
            message: null, status: null
        }
    },
    componentWillReceiveProps(nextProps) {

        var getUserName = nextProps.forgotuserName;
        this.setState({ message: getUserName.message, modal: true, status: getUserName.status });
    },
    componentDidMount() {

    },
    handelClick() {
        let isValidEmail = validate.email(this.refs.email.value);
        isValidEmail ? this.refs.email.className = 'inputText' : this.refs.email.className = 'inputText error';

        if (this.refs.email.value.trim().length == 0) {
            this.setState({ modal: true, message: "Please enter necessary fields to proceed." });
            return false;
        }

        if (!isValidEmail) { this.setState({ modal: true, message: "Please enter valid email address to proceed." }); return false; }
        else {
            this.props.Dispatch(UserActions.forgotuserName('?email=' + this.refs.email.value));
        }

    },
    sendBack() {
        this.props.router.push('/');
    },
    closebox() {
        if (this.state.status === 200) {
            this.props.router.push('/');

        } else {
            this.setState({ modal: false });
        }

    },
    handleKeyPress(e) {
        if (e.key === 'Enter') {
            this.handelClick();
        }

    },

    email_validate(event) {
        validate.email(event.target.value) ? event.target.className = 'inputText' : event.target.className = 'inputText error';
    },

    remove_error(event) {
        event.target.type === "text" ? event.target.className = 'inputText' : event.target.className = '';
    },

    render() {
        return (
            <div className="vertalign-container">

                <div className="vertalign-child">
                    <h1 className="top-logo">MOBI</h1>
                    <div className="admin-login forgot-username">
                        <span onClick={this.sendBack} className="icon-backarrow"></span>
                        <p className="login-head">Forgot your username?</p>
                        <p>Enter your registered Email address below and we'll get you back on track.</p>
                        <div className="input-group">
                            <input type="text" className="inputText" required ref="email" onKeyPress={this.handleKeyPress} onFocus={this.remove_error} onBlur={this.email_validate} />
                            <span className="floating-label">Email</span>
                        </div>

                        <button className="gray-button admin-login-button" onClick={this.handelClick}>Retrieve UserName</button>
                    </div>
                </div>
                <div> {this.state.modal ? <ModalDialogCommon message={this.state.message} action={this.closebox} /> : ""}</div>
            </div>
        );
    }
});

let mapStateToProps = (state) => {
    return {
        forgotuserName: state.User.getUserName
    };
};

let mapDispatchToProps = (dispatch) => ({
    // UserActions: bindActionCreators(UserActions, dispatch),
    Dispatch: dispatch
});
export default connect(mapStateToProps,
    mapDispatchToProps)(withRouter(ForgotUname));



/** WEBPACK FOOTER **
 ** ./src/components/forgotUname.js
 **/